<main class="processo-list">
  <div class="header_search">
    <div class="title-page">
      <h3>{{route.toLocaleUpperCase()}}s</h3>
    </div>
    <div class="content_search">
      <div class="search">
        <input type="text" class="form-control" aria-describedby="basic-addon1" [(ngModel)]="filterPesquisa" (keyup)="pesquisaRapida()" autocomplete="off">
        <span class="icon-search" id="basic-addon1">
          <img src="assets/images/svgs/pesquisa.svg" alt="Pesquisar">
        </span>
      </div>
      <div class="new-project btn-wx" *ngIf="!blocked">
        <a class="btn btn-primary" type="button" [routerLink]="[route + '/create']">Novo {{route.toLocaleUpperCase()}}</a>
      </div>
      <div class="new-project btn-wx" *ngIf="blocked && project">
        <a class="btn btn-disabled" type="button" title="O projeto está bloqueado, por isso não é possível criar Novos processos">Novo {{route.toLocaleUpperCase()}}</a>
      </div>
    </div>
  </div>


  <div class="system-table table-container">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Nº do Processo</th>
            <th>Assunto</th>
            <th>Atividade Atual</th>
            <th>Data de Recebimento</th>
            <th>Unidade de origem</th>
            <th>Unidade portadora </th>
            <th>Vinculação SMG</th>
            <th class="text-center btn-icon-td">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of processoPesquisa">
            <tr>
              <td class="title title-processo">
                {{onMaskProcesso(item.numero_processo)}}
                <div class="responsavel">
                  <div *ngFor="let selos of item?.selos">
                    <div *ngIf="selos == 'Estratégico'" class="tag">Estratégico</div>
                  </div>
                  <div *ngIf="item?.privacidade == 'Processo Privado'" class="tag irfe">Privado</div>
                </div>
              </td>
              <td>{{item?.tipo_processo}}</td>
              <td>{{item?.atividade_atual}}</td>
              <td>
                <div class="m-b-xs">
                  {{item?.data_recebimento}}
                </div>
                <strong *ngIf="item?.data_recebimento_dias">há {{item?.data_recebimento_dias}} dias</strong>
              </td>
              <td>
                {{item?.orgao_origem}}
              </td>
              <td>
                {{item?.orgao_portador}}
              </td>
              <td>
                <div *ngFor="let link of getVinculos(item?.vinculos)" class="m-b-xs">
                  <strong>{{link?.label}}</strong>:
                  <a routerLink="../{{link?.route}}">{{link.text}}</a>
                </div>
              </td>
              <td>
                <div class="btn-icon">
                  <button class="btn btn-white btn-font-icon"  (click)="item.processo_description_active = !item.processo_description_active"
                    title="{{item.processo_description_active? 'Fechar':'Abrir'}} descrição">{{item.processo_description_active? 'zoom_out': 'zoom_in'}}</button>
                  <a class="btn btn-white btn-font-icon ms-1" *ngIf="item.route" href="{{item.route}}" target="_blank"
                    title="Abrir processo" >open_in_new</a>
                  <a class="btn btn-white btn-font-icon ms-1" [routerLink]="[route + '/edit/' + item.id]" title="Editar">edit</a>
                </div>
              </td>
            </tr>
            <tr *ngIf="item?.processo_description_active">
              <td class="title">
                <strong>Descrição:</strong>
              </td>
              <td class="text-left" colspan="7">
                {{ item?.descricao ?? "Sem Descrição" }}
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!processo?.length && !isLoading" class="border-b-radius">
            <td colspan="8" class="text-center">Nenhum {{route.toLocaleUpperCase()}} Encontrado.</td>
          </tr>
          <tr *ngIf="!processo?.length && isLoading" class="border-b-radius">
            <td colspan="8" class="text-center">Carregando...</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>
<app-loading [loader]="isLoading"></app-loading>
